export const trackEvent = (name, params) => {
  window.gtag && window.gtag("event", name, params);
};

export const trackLead = (params) => {
  trackEvent("generate_lead", params);
  window.fbq && window.fbq("track", "Lead");
};

const CONTACT_LINK_EVENTS = [
  ["tel:", "contact_phone"],
  ["https://wa.me/", "contact_whatsapp"],
  ["mailto:", "contact_email"],
];

const onDocumentClick = (e) => {
  if (!(e.target instanceof Element)) return;
  const link = e.target.closest("a[href]");
  if (!link) return;
  const href = link.getAttribute("href") || "";
  const match = CONTACT_LINK_EVENTS.find(([prefix]) => href.startsWith(prefix));
  if (match) trackEvent(match[1], { link_location: window.location.pathname });
};

export const installContactLinkTracking = () => {
  document.addEventListener("click", onDocumentClick);
};
